import React, { useState } from 'react';

const reports = [
  { id: 1, title: 'Q1 2026 Revenue Summary',     type: 'Finance',   date: 'Mar 31, 2026', size: '2.4 MB', status: 'Ready'      },
  { id: 2, title: 'Monthly User Growth Report',   type: 'Users',     date: 'Mar 28, 2026', size: '1.1 MB', status: 'Ready'      },
  { id: 3, title: 'Marketing Campaign Analysis',  type: 'Marketing', date: 'Mar 25, 2026', size: '3.7 MB', status: 'Ready'      },
  { id: 4, title: 'Infrastructure Cost Report',   type: 'DevOps',    date: 'Mar 20, 2026', size: '890 KB', status: 'Ready'      },
  { id: 5, title: 'Q2 2026 Forecast',             type: 'Finance',   date: 'Apr 1, 2026',  size: '—',      status: 'Generating' },
  { id: 6, title: 'Customer Satisfaction Survey', type: 'Users',     date: 'Apr 2, 2026',  size: '—',      status: 'Scheduled'  },
  { id: 7, title: 'SEO Performance Breakdown',    type: 'Marketing', date: 'Mar 15, 2026', size: '1.5 MB', status: 'Ready'      },
  { id: 8, title: 'Annual Security Audit',        type: 'DevOps',    date: 'Feb 28, 2026', size: '5.2 MB', status: 'Ready'      },
];

const typeColors = {
  Finance:   { bg: 'rgba(78,115,223,0.12)',  color: '#4e73df' },
  Users:     { bg: 'rgba(28,200,138,0.12)',  color: '#1cc88a' },
  Marketing: { bg: 'rgba(246,194,62,0.15)',  color: '#c9a227' },
  DevOps:    { bg: 'rgba(111,66,193,0.12)',  color: '#6f42c1' },
};

const statusColors = {
  Ready:      { bg: 'rgba(28,200,138,0.12)',  color: '#1cc88a' },
  Generating: { bg: 'rgba(246,194,62,0.15)',  color: '#c9a227' },
  Scheduled:  { bg: 'rgba(78,115,223,0.12)',  color: '#4e73df' },
};

export default function Reports() {
  const [filter, setFilter] = useState('All');
  const types = ['All', 'Finance', 'Users', 'Marketing', 'DevOps'];
  const filtered = filter === 'All' ? reports : reports.filter((r) => r.type === filter);

  return (
    <div>
      {/* Stats */}
      <div className="stats-grid" style={{ marginBottom: 28 }}>
        {[
          { label: 'Total Reports',  value: '48',  accent: '#4e73df' },
          { label: 'Ready',          value: '41',  accent: '#1cc88a' },
          { label: 'Generating',     value: '3',   accent: '#f6c23e' },
          { label: 'Scheduled',      value: '4',   accent: '#6f42c1' },
        ].map((s) => (
          <div key={s.label} className="card" style={{ borderLeft: `4px solid ${s.accent}` }}>
            <div className="card-body py-3">
              <div className="card-title">{s.label}</div>
              <div className="stat-value">{s.value}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="card">
        <div className="card-body">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
            <p className="section-title" style={{ margin: 0 }}>All Reports</p>
            <div style={{ display: 'flex', gap: 8 }}>
              {types.map((t) => (
                <button
                  key={t}
                  onClick={() => setFilter(t)}
                  style={{ padding: '5px 14px', borderRadius: 20, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: '1px solid var(--border-color)', background: filter === t ? '#4e73df' : 'transparent', color: filter === t ? '#fff' : 'var(--text-muted)', transition: 'all 0.2s' }}
                >
                  {t}
                </button>
              ))}
            </div>
          </div>
          <table className="dash-table">
            <thead>
              <tr>{['Title', 'Type', 'Date', 'Size', 'Status', ''].map((h) => <th key={h}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {filtered.map((r) => (
                <tr key={r.id}>
                  <td style={{ fontWeight: 600 }}>{r.title}</td>
                  <td><span className="badge-status" style={typeColors[r.type]}>{r.type}</span></td>
                  <td style={{ color: 'var(--text-muted)' }}>{r.date}</td>
                  <td style={{ color: 'var(--text-muted)' }}>{r.size}</td>
                  <td><span className="badge-status" style={statusColors[r.status]}>{r.status}</span></td>
                  <td>
                    {r.status === 'Ready' && (
                      <button style={{ padding: '4px 14px', borderRadius: 6, fontSize: 12, fontWeight: 600, cursor: 'pointer', border: '1px solid #4e73df', background: 'transparent', color: '#4e73df', transition: 'all 0.2s' }}
                        onMouseEnter={(e) => { e.target.style.background = '#4e73df'; e.target.style.color = '#fff'; }}
                        onMouseLeave={(e) => { e.target.style.background = 'transparent'; e.target.style.color = '#4e73df'; }}
                      >
                        Download
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
